// extracted by mini-css-extract-plugin
export default {"teampage":"teampage_teampage__TMf2n"};